/**
 * The query keys the reads in this folder are cached under.
 *
 * They live apart from the queries themselves so that anything needing to
 * invalidate one can reach it without importing a query module and closing an
 * import cycle — creating or renaming a team has to clear the team options, and
 * that write lives in another module's cache file.
 */

// The team options behind every team picker and team filter.
export const TEAM_FILTER_OPTIONS_QUERY_KEY = 'teamFilterOptions';

// The user options, narrowed by the teams already chosen.
export const USER_FILTER_OPTIONS_QUERY_KEY = 'userFilterOptions';

// The device options, narrowed by the teams already chosen.
export const DEVICE_FILTER_OPTIONS_QUERY_KEY = 'deviceFilterOptions';
